import styled from 'styled-components';

import RoundArrowSvg from './assets/icons/round-arrow.svg';

const RoundArrowIcon = styled(RoundArrowSvg)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
  &:hover {
    cursor: pointer;
  }
`;

export default RoundArrowIcon;
